import React, { useState, useEffect } from 'react';
import { Modal, Button, InputGroup, FormControl } from 'react-bootstrap';
import { updateDb } from "../services/updateDb"; // Import the updateDb service
import PasswordChecklist from "react-password-checklist";
import { useTranslation } from "react-i18next";

const PasswordChangeModal = ({show, handleClose}) => {
  const { t, i18n } = useTranslation();
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [passwordError, setPasswordError] = useState(null);

  const handleChangePassword = async () => {
    try {
      if(!isPasswordValid) {
        setPasswordError(t('new_password_not_valid'));
        return;
      }

      const response = await updateDb('/api/users/change-password', { currentPassword, password }, "post");
      if (response.success) {
        setPasswordError(null);
        setPasswordSuccess(true);
        // refetchUserData(); // Refetch user data to update 2FA status
        // handleClose();
      } else {
        setPasswordError(response.error);
      }
    }
    catch (error) {
      setPasswordError('Error changing password: ' + error);
    }
  };


  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t('change_password')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {passwordSuccess && (
          <div className="alert alert-success" role="alert">
            {t('password')} {t('updated')}
          </div>
        )}
        {passwordError && (
          <div className="alert alert-danger" role="alert">
            {passwordError}
          </div>
        )}
        {(!passwordSuccess) && (
        <>
            <p>{t('fill_in_existing_pwd')}</p>

            <InputGroup className="mb-3">
                <FormControl
                    placeholder={t('current_password')}
                    type="password"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                />
            </InputGroup>

            <InputGroup className="mb-3">
                <FormControl
                    placeholder={t('new_password')}
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </InputGroup>
            <InputGroup className="mb-3">
                <FormControl
                    placeholder={t('confirm_new_password')}
                    type="password"
                    value={passwordAgain}
                    onChange={(e) => setPasswordAgain(e.target.value)}
                />
            </InputGroup>

            {(password || passwordAgain) && (<PasswordChecklist
                rules={["minLength","specialChar","number","capital","lowercase", "match"]}
                minLength={12}
                value={password}
                valueAgain={passwordAgain}
                onChange={(isValid) => {
                  setIsPasswordValid(isValid);
                }}
                messages={{
                  minLength: t('password_min_length'),
                  specialChar: t('password_special_char'),
                  number: t('password_number'),
                  capital: t('password_capital'),
                  lowercase: t('password_lowercase'),
                  match: t('password_match')
                }}
            />)}

        </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="white-border-btn cancel-btn" onClick={handleClose}>
          {t('cancel')}
        </div>
  
        {(!passwordSuccess) && (
          <div className="white-border-btn submit-btn" onClick={handleChangePassword}>
            {t('change_password')}
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default PasswordChangeModal;